import { defineComponent as n, computed as s, openBlock as o, createElementBlock as c, normalizeStyle as u, normalizeClass as m, unref as p, renderSlot as h } from "vue";
import { useNamespace as i } from "./index559.js";
var _ = /* @__PURE__ */ n({
  name: "ElHeader",
  __name: "header",
  props: {
    height: { type: [String, null], required: !1, default: null }
  },
  setup(t) {
    const e = t, r = i("header"), a = s(() => e.height ? r.cssVarBlock({
      height: e.height
    }) : {});
    return (l, d) => (o(), c(
      "header",
      {
        class: m(p(r).b()),
        style: u(a.value)
      },
      [
        h(l.$slots, "default")
      ],
      6
      /* CLASS, STYLE */
    ));
  }
});
export {
  _ as default
};
